"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowParser = void 0;
var column_1 = require("./column");
var Token_1 = require("./Token");
var EMPTY_STRING = '';
var RowParser = /*#__PURE__*/function () {
  function RowParser(parserOptions) {
    _classCallCheck(this, RowParser);
    _defineProperty(this, "parserOptions", void 0);
    _defineProperty(this, "columnParser", void 0);
    this.parserOptions = parserOptions;
    this.columnParser = new column_1.ColumnParser(parserOptions);
  }
  return _createClass(RowParser, [{
    key: "parse",
    value: function parse(scanner) {
      var parserOptions = this.parserOptions;
      var hasMoreData = scanner.hasMoreData;
      var currentScanner = scanner;
      var columns = [];
      var currentToken = this.getStartToken(currentScanner, columns);
      while (currentToken) {
        if (Token_1.Token.isTokenRowDelimiter(currentToken)) {
          currentScanner.advancePastToken(currentToken);
          // if ends with CR and there is more data, keep unparsed due to possible
          // coming LF in CRLF
          if (!currentScanner.hasMoreCharacters && Token_1.Token.isTokenCarriageReturn(currentToken, parserOptions) && hasMoreData) {
            return null;
          }
          currentScanner.truncateToCursor();
          return columns;
        }
        if (!this.shouldSkipColumnParse(currentScanner, currentToken, columns)) {
          var item = this.columnParser.parse(currentScanner);
          if (item === null) {
            return null;
          }
          columns.push(item);
        }
        currentToken = currentScanner.nextNonSpaceToken;
      }
      if (!hasMoreData) {
        currentScanner.truncateToCursor();
        return columns;
      }
      return null;
    }
  }, {
    key: "getStartToken",
    value: function getStartToken(scanner, columns) {
      var currentToken = scanner.nextNonSpaceToken;
      if (currentToken !== null && Token_1.Token.isTokenDelimiter(currentToken, this.parserOptions)) {
        columns.push('');
        return scanner.nextNonSpaceToken;
      }
      return currentToken;
    }
  }, {
    key: "shouldSkipColumnParse",
    value: function shouldSkipColumnParse(scanner, currentToken, columns) {
      var parserOptions = this.parserOptions;
      if (Token_1.Token.isTokenDelimiter(currentToken, parserOptions)) {
        scanner.advancePastToken(currentToken);
        // if the delimiter is at the end of a line
        var nextToken = scanner.nextCharacterToken;
        if (!scanner.hasMoreCharacters || nextToken !== null && Token_1.Token.isTokenRowDelimiter(nextToken)) {
          columns.push('');
          return true;
        }
        if (nextToken !== null && Token_1.Token.isTokenDelimiter(nextToken, parserOptions)) {
          columns.push('');
          return true;
        }
      }
      return false;
    }
  }], [{
    key: "isEmptyRow",
    value: function isEmptyRow(row) {
      return row.join(EMPTY_STRING).replace(/\s+/g, EMPTY_STRING) === EMPTY_STRING;
    }
  }]);
}();
exports.RowParser = RowParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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